import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { IoClose } from "react-icons/io5";
import { imgBaseUrl } from "../../Const";
import { MdOutlinePhoto } from "react-icons/md";
import { FaTable } from "react-icons/fa6";
import { MdOutlinePlayCircle } from "react-icons/md";
import { Navigation, FreeMode, Thumbs, Mousewheel } from "swiper/modules";
import "../../style/modal.css";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import NoPropertyImg from "../../images/no_property.png";

export default function MultiTabModal({ show, handleHide, propertyImgsmdl, count }) {
    const [propertyTab, setpropertyTab] = useState("All");
    const handleTab = (tab) => setpropertyTab(tab);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [thumbsSwiper1, setThumbsSwiper1] = useState(null);
    const [thumbsVDOSwiper, setThumbsVDOSwiper] = useState(null);
    const [shouldRenderSwiper, setShouldRenderSwiper] = useState(false);
    const swiperMainRef = useRef(null);

    useEffect(() => {
        let data = count.forEach((group) => {
            group.total = group.images.length;
        });
    }, [count]);
    
    useEffect(() => {
        if (show && swiperMainRef.current?.swiper) {
            // Wait for modal animation to finish, then update Swiper
            const timer = setTimeout(() => {
                swiperMainRef.current.swiper.update();
            }, 300); // adjust delay to match modal animation

            return () => clearTimeout(timer);
        }
    }, [show]);
    useEffect(() => {
        const resizeObserverError = (event) => {
            if (event.message === "ResizeObserver loop completed with undelivered notifications.") {
                event.stopImmediatePropagation();
            }
        };
        window.addEventListener("error", resizeObserverError);
        return () => {
            window.removeEventListener("error", resizeObserverError);
        };
    }, []);
    return (
        <>
            <Modal size="xl" className="modal_multi" aria-labelledby="contained-modal-title-vcenter" show={show} centered onHide={handleHide}>
                <button className="close-btn" onClick={handleHide}>
                    <IoClose />
                </button>
                <Modal.Header>
                    <div className="custom-modal-tab">
                        {propertyImgsmdl?.images?.length > 0 && (
                            <button className={`custom-tab-btn gallery-title${propertyTab == "All" ? " active" : ""}`} onClick={() => handleTab("All")}>
                                <MdOutlinePhoto /> Images ({propertyImgsmdl?.images?.filter((img) => !img.needHide)?.length})
                            </button>
                        )}
                        {propertyImgsmdl?.floorPlans?.length > 0 && (
                            <button className={`custom-tab-btn gallery-title${propertyTab == "floorPlan" ? " active" : ""}`} onClick={() => handleTab("floorPlan")}>
                                <FaTable /> Floor Plan 
                                {/* ({propertyImgsmdl?.floorPlans?.length}) */}
                            </button>
                        )}
                        {propertyImgsmdl?.videos?.length > 0 && (
                            <button className={`custom-tab-btn gallery-title${propertyTab == "video" ? " active" : ""}`} onClick={() => handleTab("video")}>
                                <MdOutlinePlayCircle /> Video ({propertyImgsmdl?.videos?.length})
                            </button>
                        )}
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="tab-content">
                        {propertyImgsmdl?.images?.length > 0 && (
                            <div className={`tab-pane ${propertyTab === "All" ? "active" : ""}`}>
                                <div className="image-slider">
                                    <Swiper
                                        loop={false}
                                        spaceBetween={10}
                                        navigation={true}
                                        slidesPerView={1}
                                        thumbs={{ swiper: thumbsSwiper }}
                                        modules={[FreeMode, Navigation, Thumbs]}
                                        className="mySwiper2"
                                    >
                                        {propertyImgsmdl.images?.filter((img) => !img.needHide).map((img) => (
                                            <SwiperSlide key={`${img?.id}-img`}>
                                                <img src={img.path ? imgBaseUrl + img.path : NoPropertyImg} alt={img?.title} loading="lazy" />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                    <Swiper
                                        onSwiper={setThumbsSwiper}
                                        loop={false}
                                        spaceBetween={10}
                                        slidesPerView={5}
                                        freeMode={true}
                                        watchSlidesProgress={true}
                                        modules={[FreeMode, Navigation, Thumbs]}
                                        className="mySwiper"
                                        breakpoints={{
                                            0: { slidesPerView: 2 },
                                            480: { slidesPerView: 3 },
                                            768: { slidesPerView: 4 },
                                            1024: { slidesPerView: 5 },
                                        }}
                                    >
                                        {propertyImgsmdl.images?.filter((img) => !img.needHide).map((img, i) => (
                                            <SwiperSlide key={`img-${img?.id}`}>
                                                <img src={img.path ? imgBaseUrl + img.path : NoPropertyImg} alt={img?.title}loading="lazy" />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            </div>
                        )}
                        {propertyImgsmdl?.floorPlans?.length > 0 && (
                            <div className={`tab-pane ${propertyTab === "floorPlan" ? "active" : ""}`}>
                                <div className="image-slider floor-image-slider">
                                    <Swiper
                                        loop={false}
                                        spaceBetween={10}
                                        navigation={true}
                                        slidesPerView={1}
                                        thumbs={{ swiper: thumbsSwiper1 }}
                                        modules={[FreeMode, Navigation, Thumbs]}
                                        className="mySwiper2"
                                    >
                                        {propertyImgsmdl.floorPlans.map((plan, index) => (
                                            <React.Fragment key={`plan-${index}`}>
                                                {plan.twoDPath && (
                                                    <SwiperSlide >
                                                        <div className="swiper-image">
                                                            <img
                                                                src={imgBaseUrl + plan.twoDPath}
                                                                onError={({ currentTarget }) => {
                                                                    currentTarget.onerror = null;
                                                                    currentTarget.src = `${NoPropertyImg}`;
                                                                }}
                                                                alt={plan?.fileNameTwoD}
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </SwiperSlide>
                                                )}
                                                {plan.threeDPath && (
                                                    <SwiperSlide>
                                                        <div className="swiper-image">
                                                            <img
                                                                src={imgBaseUrl + plan.threeDPath}
                                                                onError={({ currentTarget }) => {
                                                                    currentTarget.onerror = null;
                                                                    currentTarget.src = `${NoPropertyImg}`;
                                                                }}
                                                                alt={plan?.fileNameThreeD}
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </SwiperSlide>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </Swiper>
                                    <Swiper
                                        onSwiper={setThumbsSwiper1}
                                        loop={false}
                                        spaceBetween={10}
                                        slidesPerView={5}
                                        freeMode={true}
                                        watchSlidesProgress={true}
                                        modules={[FreeMode, Navigation, Thumbs]}
                                        className="mySwiper"
                                        breakpoints={{
                                            0: { slidesPerView: 2 },
                                            480: { slidesPerView: 3 },
                                            768: { slidesPerView: 4 },
                                            1024: { slidesPerView: 5 },
                                        }}
                                    >
                                        {propertyImgsmdl.floorPlans.map((plan, index) => (
                                            <React.Fragment key={`3d-${index}`}>
                                                {plan.twoDPath && (
                                                    <SwiperSlide>
                                                        <div className="slider-image">
                                                            <img
                                                                src={imgBaseUrl + plan.twoDPath}
                                                                onError={({ currentTarget }) => {
                                                                    currentTarget.onerror = null;
                                                                    currentTarget.src = `${NoPropertyImg}`;
                                                                }}
                                                                alt={plan.fileNameTwoD}
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </SwiperSlide>
                                                )}
                                                {plan.threeDPath && (
                                                    <SwiperSlide>
                                                        <div className="slider-image">
                                                            <img
                                                                src={imgBaseUrl + plan.threeDPath}
                                                                onError={({ currentTarget }) => {
                                                                    currentTarget.onerror = null;
                                                                    currentTarget.src = `${NoPropertyImg}`;
                                                                }}
                                                                alt={plan.fileNameTwoD}
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </SwiperSlide>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </Swiper>
                                </div>
                                {/* <div className="slider ">
                                    <div className="slider-col">
                                        <div className="slider-prev">
                                            <IoIosArrowUp />
                                        </div>
                                        <Swiper
                                            onSwiper={setThumbsSwiper1}
                                            direction="vertical"
                                            slidesPerView={4}
                                            spaceBetween={20}
                                            loop={false}
                                            freeMode={true}
                                            watchSlidesProgress={true}
                                            navigation={{ nextEl: ".slider-next", prevEl: ".slider-prev" }}
                                            breakpoints={{
                                                0: { direction: "vertical", slidesPerView: 1 },
                                                768: { direction: "vertical", slidesPerView: 1 },
                                                1300: { direction: "vertical", slidesPerView: 2 },
                                                1400: { direction: "vertical", slidesPerView: 4 },
                                            }}
                                            modules={[FreeMode, Navigation, Thumbs]}
                                            className="slider-thumbs"
                                        >
                                            {propertyImgsmdl.floorPlans.map((plan, i) => (
                                                <>
                                                    {plan.twoDPath && (
                                                        <SwiperSlide>
                                                            <div className="slider-image">
                                                                <img
                                                                    src={imgBaseUrl + plan.twoDPath}
                                                                    onError={({ currentTarget }) => {
                                                                        currentTarget.onerror = null;
                                                                        currentTarget.src = `${NoPropertyImg}`;
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </SwiperSlide>
                                                    )}
                                                    {plan.threeDPath && (
                                                        <SwiperSlide>
                                                            <div className="slider-image">
                                                                <img
                                                                    src={imgBaseUrl + plan.threeDPath}
                                                                    onError={({ currentTarget }) => {
                                                                        currentTarget.onerror = null;
                                                                        currentTarget.src = `${NoPropertyImg}`;
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </SwiperSlide>
                                                    )}
                                                </>
                                            ))}
                                        </Swiper>
                                        <div className="slider-next">
                                            <IoIosArrowDown />
                                        </div>
                                    </div>
                                    <div className="slider-images " style={{ flex: 1 }}>
                                        <Swiper
                                            direction="vertical"
                                            slidesPerView={1}
                                            spaceBetween={20}
                                            mousewheel={true}
                                            grabCursor={true}
                                            navigation={{ nextEl: ".slider-next", prevEl: ".slider-prev" }}
                                            thumbs={{ swiper: thumbsSwiper1 }}
                                            breakpoints={{ 0: { direction: "horizontal" }, 768: { direction: "vertical" } }}
                                            modules={[Thumbs, Navigation, Mousewheel]}
                                            className="main-swiper"
                                        >
                                            {propertyImgsmdl.floorPlans.map((plan, i) => (
                                                <>
                                                    {plan.twoDPath && (
                                                        <SwiperSlide>
                                                            <div className="swiper-image">
                                                                <img
                                                                    src={imgBaseUrl + plan.twoDPath}
                                                                    onError={({ currentTarget }) => {
                                                                        currentTarget.onerror = null;
                                                                        currentTarget.src = `${NoPropertyImg}`;
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </SwiperSlide>
                                                    )}
                                                    {plan.threeDPath && (
                                                        <SwiperSlide>
                                                            <div className="swiper-image">
                                                                <img
                                                                    src={imgBaseUrl + plan.threeDPath}
                                                                    onError={({ currentTarget }) => {
                                                                        currentTarget.onerror = null;
                                                                        currentTarget.src = `${NoPropertyImg}`;
                                                                    }}
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </SwiperSlide>
                                                    )}
                                                </>
                                            ))}
                                        </Swiper>
                                    </div>
                                </div> */}
                            </div>
                        )}
                        {propertyImgsmdl?.videos?.length > 0 && (
                            <div className={`tab-pane ${propertyTab === "video" ? "active" : ""}`}>
                                <div className="slider-1">
                                    <Swiper
                                        //  ref={swiperMainRef}
                                        loop={false}
                                        spaceBetween={10}
                                        navigation={true}
                                        slidesPerView={1}
                                        thumbs={{ swiper: thumbsSwiper }}
                                        modules={[FreeMode, Navigation, Thumbs]}
                                        className="main-swiper"
                                        onSwiper={setThumbsVDOSwiper}
                                    >
                                        {propertyImgsmdl.videos.map((vdo) => (
                                            <SwiperSlide key={`${vdo?.id}-video`}>
                                                <div className="video-slider-image">
                                                    <video controls>
                                                        <source src={imgBaseUrl + vdo?.path} type="video/mp4" />
                                                    </video>
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                                {/* <div className="slider">
                                    <div className="slider-col">
                                        <div className="slider-prev">
                                            <IoIosArrowUp />
                                        </div>
                                        <Swiper
                                            onSwiper={setThumbsVDOSwiper}
                                            direction="vertical"
                                            slidesPerView={4}
                                            spaceBetween={20}
                                            freeMode={true}
                                            watchSlidesProgress={true}
                                            navigation={{ nextEl: ".slider-next", prevEl: ".slider-prev" }}
                                            breakpoints={{
                                                0: { direction: "vertical", slidesPerView: 1 },
                                                768: { direction: "vertical", slidesPerView: 1 },
                                                1300: { direction: "vertical", slidesPerView: 2 },
                                                1400: { direction: "vertical", slidesPerView: 4 },
                                            }}
                                            modules={[FreeMode, Navigation, Thumbs]}
                                            className="slider-thumbs"
                                        >
                                            {propertyImgsmdl.videos.map((vdo, i) => (
                                                <SwiperSlide key={i}>
                                                    <div className="slider-image">
                                                        <video
                                                            // autoPlay loop
                                                            className="w-100"
                                                        >
                                                            <source src={imgBaseUrl + vdo?.path} type="video/mp4" />
                                                        </video>
                                                    </div>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                        <div className="slider-next">
                                            <IoIosArrowDown />
                                        </div>
                                    </div>
                                    <div className="slider-images " style={{ flex: 1 }}>
                                        <Swiper
                                            direction="vertical"
                                            slidesPerView={1}
                                            spaceBetween={20}
                                            mousewheel={true}
                                            grabCursor={true}
                                            navigation={{ nextEl: ".slider-next", prevEl: ".slider-prev" }}
                                            thumbs={{ swiper: thumbsVDOSwiper }}
                                            breakpoints={{ 0: { direction: "horizontal" }, 768: { direction: "vertical" } }}
                                            modules={[Thumbs, Navigation, Mousewheel]}
                                            className="main-swiper"
                                        >
                                            {propertyImgsmdl.videos.map((vdo, i) => (
                                                <SwiperSlide key={i}>
                                                    <div className="swiper-image">
                                                        <video
                                                            // autoPlay loop
                                                            controls
                                                            className="video-content"
                                                        >
                                                            <source src={imgBaseUrl + vdo?.path} type="video/mp4" />
                                                        </video>
                                                    </div>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </div>
                                </div> */}
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
